import { useCallback, useEffect, useRef } from 'react';

/**
 * Get a function that returns mounted status.
 *
 * @example
 *
 * function Component() {
 *   const isMounted = useIsMounted();
 *   const [state, setState] = useState();
 *   useEffect(() => {
 *     (async () => {
 *       const result = await someAsyncStuff();
 *       // Don't set state on an unmounted component
 *       if (isMounted()) {
 *         setState(result);
 *       }
 *     })();
 *   });
 *
 *   return <div>{result}</div>;
 * }
 */
export function useIsMountedGetter() {
	const ref = useRef(false);
	const getter = useCallback(() => ref.current, []);

	useEffect(() => {
		ref.current = true;

		return () => {
			ref.current = false;
		};
	}, []);

	return getter;
}
